export default __webpack_public_path__ + "static/media/menu-settings.1f7d34d1.svg";